/* eslint-disable react/prop-types,no-unused-vars */
import React from 'react';
import * as _ from 'lodash';
import {
  medicalHardshipLookup,
  jobLossHardshipLookup,
  disasterAssistanceHardshipLookup,
} from '../../../dataMapper/claimCodeMapper';
import stepMedicalHardshipDataMapper from '../../../dataMapper/stepMedicalHardshipDataMapper';
import stepJobLossHardshipDataMapper from '../../../dataMapper/stepJobLossHardshipDataMapper';
import stepDisasterAssistanceHardshipDataMapper from '../../../dataMapper/stepDisasterAssistanceHardshipDataMapper';
import { Table } from '../../../../../components/Table';
import TH from '../../../../../components/Table/TH';
import TR from '../../../../../components/Table/TR';
import TD from '../../../../../components/Table/TD';


const DocumentTableDuesProtect = (props) => {
  const renderIcon = (hasFile) => {
    if (hasFile) {
      return <i style={{ color: '#44b4a6' }} className="fa fa-check fa-2x" aria-hidden="true" />;
    }
    return <i style={{ color: 'orange' }} className="fa fa-times fa-2x" aria-hidden="true" />;
  };
  const { attachDocuments } = props.stepSupportingDocumentsData;
  const { selectedBenefits } = props.stepWhatHappenedData;
  const claimTypes = props.claimTypes;
  const list = (!!selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || []);
  const description = list.length > 0 ? list[0].description : '';
  const isStepCriticalIllnessSelected = list.filter((d) => ((medicalHardshipLookup.claimCodeList).filter((c) => c === d.claimCode && c === medicalHardshipLookup.criticalIllness.claimCode)).length > 0).length > 0;
  const isStepDisabilitySelected = list.filter((d) => ((medicalHardshipLookup.claimCodeList).filter((c) => c === d.claimCode && c === medicalHardshipLookup.disability.claimCode)).length > 0).length > 0;
  const isStepDismembermentSelected = list.filter((d) => ((medicalHardshipLookup.claimCodeList).filter((c) => c === d.claimCode && c === medicalHardshipLookup.dismemberment.claimCode)).length > 0).length > 0;
  const isStepLeaveOfAbsenceSelected = list.filter((d) => ((medicalHardshipLookup.claimCodeList).filter((c) => c === d.claimCode && c === medicalHardshipLookup.leaveOfAbsence.claimCode)).length > 0).length > 0;
  const isStepDeathSelected = list.filter((d) => ((medicalHardshipLookup.claimCodeList).filter((c) => c === d.claimCode && c === medicalHardshipLookup.death.claimCode)).length > 0).length > 0;
  const isStepJobLossHardshipSelected = (list.filter((d) => ((jobLossHardshipLookup.claimCodeList).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const isStepDisasterAssistanceHardshipSelected = (list.filter((d) => ((disasterAssistanceHardshipLookup.claimCodeList).filter((c) => c === d.claimCode)).length > 0)).length > 0;

  // Medical Hardship
  const renderCriticalIllness = () => {
    const data = stepMedicalHardshipDataMapper.mapToExpenses(props.stepMedicalHardshipData, props.userInfo, props.stepWhatHappenedData, description);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{x.nameClaimType}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.claimFor}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(((medicalHardshipLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0 && isStepCriticalIllnessSelected)}</TD>}
      </TR>
    ));
  };

  const renderDisability = () => {
    const data = stepMedicalHardshipDataMapper.mapToExpenses(props.stepMedicalHardshipData, props.userInfo, props.stepWhatHappenedData, description);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{x.nameClaimType}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.claimFor}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(((medicalHardshipLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0 && isStepDisabilitySelected)}</TD>}
      </TR>
    ));
  };

  const renderDismemberment = () => {
    const data = stepMedicalHardshipDataMapper.mapToExpenses(props.stepMedicalHardshipData, props.userInfo, props.stepWhatHappenedData, description);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{x.nameClaimType}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.claimFor}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(((medicalHardshipLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0 && isStepDismembermentSelected)}</TD>}
      </TR>
    ));
  };

  const renderLeaveOfAbsence = () => {
    const data = stepMedicalHardshipDataMapper.mapToExpenses(props.stepMedicalHardshipData, props.userInfo, props.stepWhatHappenedData, description);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{x.nameClaimType}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.claimFor}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(((medicalHardshipLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0 && isStepLeaveOfAbsenceSelected)}</TD>}
      </TR>
    ));
  };

  const renderDeath = () => {
    const data = stepMedicalHardshipDataMapper.mapToExpenses(props.stepMedicalHardshipData, props.userInfo, props.stepWhatHappenedData, description);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{x.nameClaimType}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.claimFor}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(((medicalHardshipLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0 && isStepDeathSelected)}</TD>}
      </TR>
    ));
  };

  const renderJobLossHardship = () => {
    const data = stepJobLossHardshipDataMapper.mapToExpenses(props.stepJobLossHardshipData, props.userInfo, props.stepWhatHappenedData, description);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{x.nameClaimType}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.claimFor}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(((jobLossHardshipLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0 && isStepJobLossHardshipSelected)}</TD>}
      </TR>
    ));
  };

  const renderDisasterAssistanceHardship = () => {
    const data = stepDisasterAssistanceHardshipDataMapper.mapToExpenses(props.stepDisasterAssistanceHardshipData, props.userInfo, props.stepWhatHappenedData, description);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{x.nameClaimType}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.claimFor}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(((disasterAssistanceHardshipLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0 && isStepDisasterAssistanceHardshipSelected)}</TD>}
      </TR>
    ));
  };

  return (
    <Table>
      <thead>
        <tr>
          <TH className="document-table-top document-table-left document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
          Qualifying Hardship Sought
          </TH>
          <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
          Claimed For
          </TH>
          <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
          Documents Provided
          </TH>
        </tr>
      </thead>
      <tbody>
        {isStepCriticalIllnessSelected && renderCriticalIllness()}
        {isStepDisabilitySelected && renderDisability()}
        {isStepDismembermentSelected && renderDismemberment()}
        {isStepLeaveOfAbsenceSelected && renderLeaveOfAbsence()}
        {isStepDeathSelected && renderDeath()}
        {isStepJobLossHardshipSelected && renderJobLossHardship()}
        {isStepDisasterAssistanceHardshipSelected && renderDisasterAssistanceHardship()}
      </tbody>
    </Table>
  );
};
export default DocumentTableDuesProtect;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepClaimSummary/components/DocumentTableDuesProtect/index.js